import IconButton from '@src/component/IconButton'
import Typography from '@ui/Typography'
import { XIcon } from '@ui/icons/tint/20/general'

import * as styles from './SelectionHeader.css'

interface SelectionHeaderProps {
  handleBack?(): void
  title: string
  description: string
}

const SelectionHeader = ({ handleBack, title, description }: SelectionHeaderProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.titleContainer}>
        {/*
         // @ts-expect-error Provide Typography with a component prop */}
        <Typography nowrap variant="body" color="textPrimary" className={styles.title}>
          {title}
        </Typography>
        {handleBack ? (
          // eslint-disable-next-line custom-rules/no-deprecated-buttons, @typescript-eslint/no-deprecated -- FIXME: https://linear.app/openphone/issue/UXP-4347/migrate-deprecated-buttons-to-ds-button
          <IconButton
            icon={<XIcon />}
            size={22}
            onClick={handleBack}
            className={styles.button}
            title="Close actions menu"
            tooltip={{
              themeKey: 'dark',
              colorScheme: 'call',
            }}
          />
        ) : null}
      </div>
      {/*
       // @ts-expect-error Provide Typography with a component prop */}
      <Typography variant="callout" color="textSecondary" className={styles.description}>
        {description}
      </Typography>
    </div>
  )
}

export default SelectionHeader
